import { cloneDeep, isEqual, keyBy, orderBy } from 'lodash'

import { DashboardsViews } from './types'

const MIGRATION_VERSION_PATTERN = /^\d{8}$/

const parseMigrationVersion = (version: string) =>
  MIGRATION_VERSION_PATTERN.test(version) ? +version : 0

const runMigrations = async (
  dashboardViews: DashboardsViews[],
  migrations: Record<string, any>,
  version: string,
) => {
  const dateRegex = new RegExp(/\/(\d{4}\d{2}\d{2})/)
  const orderedList = orderBy(Object.keys(migrations))
  const lastMigration = orderedList.at(-1)
  const lastMigrationDate = lastMigration && dateRegex.exec(lastMigration)?.[1]
  if (!lastMigrationDate) return null

  const parsedVersion = parseMigrationVersion(version)
  const parsedLastMigration = parseMigrationVersion(lastMigrationDate)
  if (parsedVersion >= parsedLastMigration) return null

  const originalById = keyBy(dashboardViews, 'id')
  let data = cloneDeep(dashboardViews)
  const findIndex = orderedList.findIndex(migration => {
    const migrationDate = dateRegex.exec(migration)
    return migrationDate?.[1] === version
  })
  const migrationsToRun = orderedList.slice(findIndex + 1).map(migration => migrations[migration])
  for (const migration of migrationsToRun) {
    data = await migration.default(data)
  }
  // Persist only the views that actually changed across all migrations.
  const migratedViews = data.filter(view => !isEqual(view, originalById[view.id]))
  return { migratedViews, version: lastMigrationDate }
}

export default async function runDashboardsSettingsMigrations(
  dashboardViews: DashboardsViews[],
  version: string,
) {
  const migrations = (import.meta as any).glob('../migrations/*.ts', { eager: true })
  return await runMigrations(dashboardViews, migrations, version)
}
